import { useCallback } from 'react';

import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { useHeaderRightNav } from '@perpay-web/fintech/hooks/useHeaderRightNavContext';
import { generatePhoneTemplateHref } from '@perpay-web/fintech/utils/routeUtils';
import { useConstCallback } from '@perpay-web/hooks/useConstCallback';
import { formatPhone } from '@perpay-web/utils/stringUtils';

import styles from './PaymentSetupCall.scss';

const PaymentSetupCall = ({
    onClickBack,
    onClickChat,
    onClickPhone,
    phoneNumber,
    inModal = false,
}) => {
    const onClickBackCb = useConstCallback(onClickBack);
    const renderHeaderCb = useCallback(
        () => (
            <CustomButton
                action='link'
                className={styles.back}
                onClick={onClickBackCb}
                size='small'
            >
                <span className={styles.name__block}>Back</span>
            </CustomButton>
        ),
        [onClickBackCb],
    );
    useHeaderRightNav(renderHeaderCb);

    return (
        <div className={styles.container}>
            <ResponsiveHeader className={styles.header}>
                Our team is here to help!
            </ResponsiveHeader>
            <ResponsiveCopy className={styles['free-copy']}>
                Navigating your payroll system can be a pain. Our team of
                payroll system experts is here to help!
            </ResponsiveCopy>
            <div className={styles.content}>
                <div className={styles.subheader}>Call us</div>
                <a
                    className={styles.phone}
                    href={generatePhoneTemplateHref(phoneNumber)}
                    onClick={onClickPhone}
                >
                    {formatPhone(phoneNumber)}
                </a>
                <ResponsiveCopy className={styles.copy}>
                    We are available anytime Monday through Friday between 9am
                    and 6pm Eastern Time. You can also leave us a voicemail.
                </ResponsiveCopy>
            </div>
            <div className={styles.content}>
                <div className={styles.subheader}>Live chat</div>
                <ResponsiveCopy className={styles.copy}>
                    Send us a message letting us know how we can help. Our
                    payroll experts will respond as soon as we can.
                </ResponsiveCopy>
                <CustomButton onClick={onClickChat} className={styles.button}>
                    Chat
                </CustomButton>
            </div>
            {inModal ? (
                <CustomButton
                    className={styles['modal-back-link']}
                    action='inline-link'
                    onClick={onClickBack}
                    size='small'
                >
                    Back to my instructions
                </CustomButton>
            ) : null}
        </div>
    );
};

export default PaymentSetupCall;
